<div>
  <p-table #dt class="config-devices-table" [value]="entries" dataKey="settingsEntryGuid"
    [resizableColumns]="true"
    [scrollable]="true" scrollHeight="calc(418px)"
    [customSort]="true" (sortFunction)="doCustomSort($event)">

    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn pSortableColumn="deviceName">
          Device
          <p-sortIcon field="deviceName"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="deviceDescription">
          Device Description
          <p-sortIcon field="deviceDescription"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="ipAddress">
          IP Address
          <p-sortIcon field="ipAddress"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="configName">
          Config Name
          <p-sortIcon field="configName"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="stateDetails">
          State Details
          <p-sortIcon field="stateDetails"></p-sortIcon>
        </th>
        <th pResizableColumn pSortableColumn="state">
          State
          <p-sortIcon field="state"></p-sortIcon>
        </th>
        <th class="uv-table-button-column-1">
          <!-- Action Buttons -->
        </th>
      </tr>

      <tr class="uv-table-filter">
        <th>
          <input pInputText type="text" style="width: 100%;"
            (input)="dt.filter($event.target.value, 'deviceName', 'contains')">
          </th>
          <th>
            <input pInputText type="text" style="width: 100%;"
              (input)="dt.filter($event.target.value, 'deviceDescription', 'contains')">
            </th>
            <th>
              <input pInputText type="text" style="width: 100%;"
                (input)="dt.filter($event.target.value, 'ipAddress', 'contains')">
              </th>
              <th>
                <input pInputText type="text" style="width: 100%;"
                  (input)="dt.filter($event.target.value, 'configName', 'contains')">
                </th>
                <th>
                  <input pInputText type="text" style="width: 100%;"
                    (input)="dt.filter($event.target.value, 'stateDetails', 'contains')">
                  </th>
                  <th>
                    <input pInputText type="text" style="width: 100%;"
                      (input)="dt.filter($event.target.value, 'state', 'contains')">
                    </th>
                    <th class="uv-table-button-column-1">
                      <!-- Action Buttons -->
                    </th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                  <tr [pSelectableRow]="rowData">
                    <td>
                      <span class="uv-table-value">{{rowData['deviceName']}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData['deviceDescription']}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData['ipAddress']}}</span>
                    </td>
                    <td>
                      <span class="uv-table-value">{{rowData['configName']}}</span>
                    </td>
                    <td pTooltip="{{rowData['stateDetails']}}">
                      <span class="uv-table-value">{{rowData['stateDetails']}}</span>
                    </td>
                    <td [className]="rowData['style']">
                      <span class="uv-table-value">{{rowData['state']}}</span>
                    </td>
                    <td class="uv-table-button-column-1">
                      <button type="button" class="btn btn-danger uv-first-table-button"
                        (click)="deleteDevice(rowData)" title="Remove this device from the monitor">
                        <i class="pi pi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </ng-template>

              </p-table>

              <form [formGroup]="SettingsForm">
                <div class="mb-3 row" style="margin-top: 20px; margin-bottom: 20px;">
                  <div class="col-lg-2">
                    <span>Device Credential:</span>
                  </div>
                  <select class="col-lg-3" [formControl]="DeviceCredentials">
                    @for (settings of ProtocolSettings; track settings) {
                      <option value="{{settings.GUID}}">{{settings.Name}}</option>
                    }
                  </select>
                </div>

                <div class="mb-3 row">
                  <div>
                    <input type="checkbox" style="margin-left: 10px;" [formControl]="UseHostnames" />
                    <span class="uv-checkbox-label">Use Hostnames</span>

                    <input type="checkbox" style="margin-left: 40px;" [formControl]="UseAllIpAddresses" />
                    <span class="uv-checkbox-label" title="Scan all secondary addresses to connect to device.">Use All IP addresses</span>
                  </div>
                </div>

              </form>

              <div style="margin-top: 3px;">
                <button type="button" (click)="addDevice()" pButton icon="fa fa-plus-square-o" label="Add Device"></button>
                <button type="button" (click)="refreshEntries()" pButton icon="fa fa-refresh" label="Refresh"></button>
              </div>

              <monitor-device-selector header="Select Devices to Monitor" [(visible)]="deviceSelectorVisible"
                defaultFilter="<All Devices>"
                (onOk)="onDeviceSelectorOk($event)" (onCancel)="onDeviceSelectorCancel()">
              </monitor-device-selector>

            </div>
